import { Typography, Box, styled, IconButton, Switch, Tooltip } from '@mui/material';
import { Dispatch, SetStateAction, useState } from 'react';
import { IForm } from '../../models/form/form';
import { theme } from '../../styles/themes/mainTheme';
import { useTranslation } from 'react-i18next';
import { IFormBuilding } from '../../models/form/form';

const ElementWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    paddingInline: '1.3%',
    paddingBlock: '0.3%',
    marginBottom: '0.5%',
    borderRadius: 5,
    "&:hover": {
        backgroundColor: theme.palette.grey[300],
    }
}));

interface IFormBuildingElementProps {
    formBuilding: IFormBuilding;
    onSetFormBuildingActive: (buildingForm: IFormBuilding) => void;
    buildingName: string;
}

const FormBuildingElement = ({ formBuilding, onSetFormBuildingActive, buildingName }: IFormBuildingElementProps) => {
    const { t } = useTranslation(['form']);
    return (
        <ElementWrapper>
            <Box>
                <Typography display={'inline'} sx={{ fontWeight: '500', marginRight: 2 }}>
                    {buildingName}
                </Typography>
            </Box>

            <Box>
                <Tooltip title={t("form:activeSwitchTooltip")} placement='top' arrow><Switch checked={formBuilding.isActive} onChange={() => onSetFormBuildingActive(formBuilding)} size='small' /></Tooltip>
            </Box>
        </ElementWrapper>
    );
}

export default FormBuildingElement;
